import { AdminUserPermissionsEnum, VerificationTypesEnum } from '@/lib/enum.ts';
import { SecuredComponent } from '@/components/hoc';
import { MessageCircleWarning } from 'lucide-react';
import { Button } from '@/components/ui';
import { Link } from 'react-router-dom';
import routes from '@/lib/routes';
import { cn } from '@/lib/utils';

type TProps = {
	type?: VerificationTypesEnum;
	tab?: 'users' | 'verifiers';
	className?: string;
	showIcon?: boolean;
};

const ButtonsShowReports = ({ type, tab, showIcon, className }: TProps) => (
	<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.REPORT]}>
		<Link to={routes.nav.reports.getHref({ type, tab })}>
			<Button
				variant={'link'}
				className={cn(
					'flex items-center space-x-1 text-purple-600 text-sm',
					className
				)}
				size={'sm'}>
				{
					showIcon &&
					<MessageCircleWarning size={16} />
				}
				<span>
					Signalements
				</span>
			</Button>
		</Link>
	</SecuredComponent>
);

export default ButtonsShowReports;
